import React from 'react';
import IntroSection from '../../component/introSection';
import MemberInfo from './component/memberInfo';

const MemberBoard : React.FC = () => (
  <div
    id="members"
  >
    <IntroSection
      title="[회원 현황]"
      content={'인생의 아름다운 2막을\n함께하는 등반자'}
    />
    <MemberInfo />
  </div>
);

export default MemberBoard;
